import EcoTextTc from 'eco-design/sections/eco-text-tc';
import styles from './index.module.scss';

export default function Comp() {
    const items = [
        {
            title: '1. 0-80% in 48 minutes was measured in optimal conditions using the EcoFlow Smart Generator 4000 (Dual Fuel) and Solar Panels, total 3960W input.',
        },
        {
            title: '2. 0-80% in 43 minutes was measured in optimal conditions using the EcoFlow Smart Generator 4000 (Dual Fuel).',
        },
        {
            title: '3. Based on proper product usage, DELTA 3 Max Plus (2048Wh) is estimated to have a lifespan of approximately 10 years, according to internal simulation test data. This information is for reference only; actual user experience may vary.',
        },
    ];
    return <EcoTextTc items={items} className={styles.comp} theme="black" />;
}
